(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/header/assets/javascripts/header.js') >= 0) return;  svs.modules.push('/components/components/header/assets/javascripts/header.js');

'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.components = svs.components || {};
var Header = function () {
  function Header(templates) {
    var _svs$core$config$data,
      _svs$core$config$data2,
      _this = this;
    _classCallCheck(this, Header);
    _defineProperty(this, "templateName", (_svs$core$config$data = svs.core.config.data.svsconfig) !== null && _svs$core$config$data !== void 0 && _svs$core$config$data.isSelfService ? 'svsheader_selfservice_title' : 'svsheader');
    _defineProperty(this, "$el", (_svs$core$config$data2 = svs.core.config.data.svsconfig) !== null && _svs$core$config$data2 !== void 0 && _svs$core$config$data2.isSelfService ? $('.js-header-selfservice-title') : $('.js-top-content'));
    _defineProperty(this, "$window", $(window));
    _defineProperty(this, "$body", $(document.body));
    _defineProperty(this, "$fixedTopContent", $('.js-fixed-top-content'));
    _defineProperty(this, "$topContentWrapper", $('.js-top-content-wrapper'));
    _defineProperty(this, "$fixedTopContentHeight", void 0);
    _defineProperty(this, "$topContentWrapperHeight", void 0);
    _defineProperty(this, "noShadowCSSClass", 'header-no-shadow');
    _defineProperty(this, "noShadowCSSClassBranding", '');
    _defineProperty(this, "log", new svs.core.log.Logger('svs.components.Header'));
    _defineProperty(this, "templates", void 0);
    _defineProperty(this, "listeningToScroll", false);
    _defineProperty(this, "triggerVisibility", false);
    _defineProperty(this, "limitToBreakpoints", []);
    _defineProperty(this, "headerVisibilityThreshold", svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? 88 : 44);
    _defineProperty(this, "headerVisible", true);
    _defineProperty(this, "_changeListener", function () {
      return _this._listenToBreakpointChange();
    });
    _defineProperty(this, "_scrollListener", _.throttle(function () {
      var scrollTop = _this.$window.scrollTop();
      if (_this.triggerVisibility) {
        _this._headerVisibilityChange(_this._getHeaderVisibility(scrollTop));
      }
      if (_this.hasInfobarAtTopFlag) {
        _this._infobarVisibilityChange(scrollTop > 0);
      }
    }, 50));
    _defineProperty(this, "setShrinkableHeader", function () {
      _this._setupHeaderScaleListerners();
    });
    this.templates = templates;
    svs.core.detect.breakpoint.on('change', function () {
      return _this.updateCachedHeights();
    });
    if (!this.$topContentWrapper.length) {
      this.$topContentWrapper = this.$fixedTopContent;
    }
    this.$window.on('scroll', this._scrollListener);
    this.setupMobileListeners();
    svs.core.template.on('configUpdate', function (e) {
      return _this.onTemplateConfigUpdate(e);
    });
  }
  return _createClass(Header, [{
    key: "_setupHeaderScaleListerners",
    value: function _setupHeaderScaleListerners() {
      var isMaxHeight;
      var navShowing;
      var self = this;
      var body = document.body;
      var maxHeaderHeight = 88;
      var updateHeaderScale = function updateHeaderScale() {
        var currentNavShowing = svs.core.detect.breakpoint.current === 'lg' || svs.core.detect.breakpoint.current === 'xl';
        var currentIsMaxHeight = window.pageYOffset >= maxHeaderHeight;
        if (currentNavShowing !== navShowing) {
          if (currentNavShowing) {
            body.classList.add('header-shrinkable');
          } else {
            body.classList.remove('header-shrinkable');
            body.classList.remove('header-shrinked');
          }
          self.updateCachedHeights();
        }
        if (currentNavShowing) {
          if (isMaxHeight !== currentIsMaxHeight || currentNavShowing !== navShowing) {
            if (currentIsMaxHeight) {
              body.classList.add('header-shrinked');
            } else {
              body.classList.remove('header-shrinked');
            }
            setTimeout(function () {
              self.updateCachedHeights();
            }, 250);
          }
        }
        isMaxHeight = currentIsMaxHeight;
        navShowing = currentNavShowing;
      };
      body.classList.add('header-shrinkable');
      window.addEventListener('resize', updateHeaderScale, {
        passive: true
      });
      window.addEventListener('scroll', updateHeaderScale, {
        passive: true
      });
      updateHeaderScale();
    }
  }, {
    key: "_getHeaderVisibility",
    value: function _getHeaderVisibility() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$window.scrollTop();
      var result = scrollTop < this.headerVisibilityThreshold;
      if (result) {
        this.trigger('headerVisibleScroll', scrollTop);
      }
      return result;
    }
  }, {
    key: "_headerVisibilityChange",
    value: function _headerVisibilityChange(visible) {
      if (this.headerVisible !== visible) {
        this.headerVisible = Boolean(visible);
        if (this.headerVisible) {
          this.trigger('headerVisibilityChange', true);
          this.$body.removeClass('header-hidden');
        } else {
          this.trigger('headerVisibilityChange', false);
          this.$body.addClass('header-hidden');
        }
        this.trigger('headerVisibleScroll', this.$window.scrollTop());
      }
    }
  }, {
    key: "updateCachedHeights",
    value: function updateCachedHeights() {
      if (this.$fixedTopContentHeight) {
        this.$fixedTopContentHeight = this.$fixedTopContent.height();
      }
      if (this.$topContentWrapperHeight) {
        this.$topContentWrapperHeight = this.$topContentWrapper.height();
      }
    }
  }, {
    key: "getFixedTopContentWrapperHeight",
    value: function getFixedTopContentWrapperHeight() {
      if (!this.$fixedTopContentHeight) {
        this.$fixedTopContentHeight = this.getFixedTopContentWrapper().height();
      }
      return this.$fixedTopContentHeight;
    }
  }, {
    key: "getTopContentWrapperHeight",
    value: function getTopContentWrapperHeight() {
      if (!this.$topContentWrapperHeight) {
        this.$topContentWrapperHeight = this.getTopContentWrapper().height();
      }
      return this.$topContentWrapperHeight;
    }
  }, {
    key: "getFixedTopContentWrapper",
    value: function getFixedTopContentWrapper() {
      return this.$fixedTopContent;
    }
  }, {
    key: "setFixedTopContentWrapper",
    value: function setFixedTopContentWrapper($newWrapper) {
      if (this.$fixedTopContent === this.$topContentWrapper) {
        this.$fixedTopContent = this.$topContentWrapper = $newWrapper;
        delete this.$fixedTopContentHeight;
        delete this.$topContentWrapperHeight;
      } else {
        delete this.$fixedTopContentHeight;
        this.$fixedTopContent = $newWrapper;
      }
    }
  }, {
    key: "getTopContentWrapper",
    value: function getTopContentWrapper() {
      return this.$topContentWrapper;
    }
  }, {
    key: "_listenToBreakpointChange",
    value: function _listenToBreakpointChange() {
      this.triggerVisibility = Boolean(~this.limitToBreakpoints.indexOf(svs.core.detect.breakpoint.current));
      if (!this.triggerVisibility) {
        this._headerVisibilityChange(true);
      } else {
        this._listenToScroll(this.triggerVisibility);
        this._headerVisibilityChange(this._getHeaderVisibility());
      }
    }
  }, {
    key: "_listenToScroll",
    value: function _listenToScroll(listen) {
      if (this.listeningToScroll !== listen) {
        if (listen) {
          this.listeningToScroll = true;
          this.$window.on('scroll', this._scrollListener);
        } else if (!listen && !this.hasInfobarAtTopFlag && !this.triggerVisibility) {
          this.listeningToScroll = false;
          this.$window.off('scroll', this._scrollListener);
        }
      }
    }
  }, {
    key: "triggerOnHeaderVisibilityChange",
    value: function triggerOnHeaderVisibilityChange(triggerVisibility, limitToBreakpoints) {
      if (triggerVisibility && this.limitToBreakpoints.length) {
        if (limitToBreakpoints) {
          this.log.info('headerVisibilityTrigger called again when already set with limits, merging limits');
          this.limitToBreakpoints = _.union(this.limitToBreakpoints, limitToBreakpoints);
        } else {
          this.log.info('headerVisibilityTrigger called again when already set with limits, removing limits');
          this.limitToBreakpoints.length = 0;
          svs.core.detect.breakpoint.off('change', this._changeListener);
          this._listenToScroll(this.triggerVisibility);
          this._scrollListener();
        }
      } else if (triggerVisibility !== this.triggerVisibility) {
        this.triggerVisibility = Boolean(triggerVisibility);
        this.limitToBreakpoints = this.triggerVisibility ? limitToBreakpoints : this.limitToBreakpoints.length = 0;
        if (limitToBreakpoints) {
          if (this.triggerVisibility) {
            svs.core.detect.breakpoint.on('change', this._changeListener);
            this._listenToBreakpointChange();
          } else {
            svs.core.detect.breakpoint.off('change', this._changeListener);
            this._listenToScroll(false);
          }
        } else {
          svs.core.detect.breakpoint.off('change', this._changeListener);
          this._listenToScroll(this.triggerVisibility);
          this._scrollListener();
        }
      }
    }
  }, {
    key: "hasChanged",
    value: function hasChanged(e, key) {
      return e.changed.indexOf(key) !== -1;
    }
  }, {
    key: "onTemplateConfigUpdate",
    value: function onTemplateConfigUpdate(e) {
      if (this.hasChanged(e, 'headerClass')) {
        this.changeTopContent(e.config.headerClass);
      }
      if (this.hasChanged(e, 'headerNoScrollClass')) {
        this.noShadowCSSClassBranding = e.config.headerNoScrollClass ? e.config.headerNoScrollClass : '';
        if (this.noShadowCSSClassBranding) {
          this.$window.on('scroll', this._scrollListener);
        } else {
          this.$window.off('scroll', this._scrollListener);
        }
        this.handleScroll();
      }
      if (this.hasChanged(e, 'title') || this.hasChanged(e, 'leftButtons') || this.hasChanged(e, 'rightButtons')) {
        var _svs$core$config$data3;
        var data;
        if ((_svs$core$config$data3 = svs.core.config.data.svsconfig) !== null && _svs$core$config$data3 !== void 0 && _svs$core$config$data3.isSelfService) {
          data = e.config.title;
        } else {
          data = {
            title: e.config.title,
            leftButtons: e.config.leftButtons,
            rightButtons: e.config.rightButtons
          };
        }
        this.render(data);
        this.setupButtonListeners(e.config.leftButtons);
        this.setupButtonListeners(e.config.rightButtons);
        this.setupMobileListeners();
      }
    }
  }, {
    key: "contextMenuClick",
    value: function contextMenuClick(e) {
      var _this2 = this;
      e.preventDefault();
      svs.core.module.load('/cl/components/contextual-menu', null, function (error) {
        if (error) {
          _this2.log.error('Failed to load components/contextual-menu', error);
        }
        if (svs.components.contextualMenu) {
          svs.components.contextualMenu.toggleVisibility();
        }
      });
    }

  }, {
    key: "changeTopContent",
    value: function changeTopContent(cssClass) {
      var topContentEl = document.getElementById('top-content');
      var classes = topContentEl.className.split(/\s+/);
      var _iterator = _createForOfIteratorHelper(classes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var className = _step.value;
          if (/header-\w*/i.test(className)) {
            topContentEl.classList.remove(className);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      topContentEl.classList.add(cssClass);
    }

  }, {
    key: "render",
    value: function render(data) {
      this.$el.html(this.templates[this.templateName](data || {}));
    }

  }, {
    key: "setupMobileListeners",
    value: function setupMobileListeners() {
      if (svs.core.detect.formfactor.mobile()) {
        $('.js-top-contextual').on('click', this.contextMenuClick.bind(this));
      }
    }

  }, {
    key: "setupButtonListeners",
    value: function setupButtonListeners(buttons) {
      if (buttons) {
        for (var i = 0; i < buttons.length; i++) {
          if (buttons[i].id && buttons[i].action) {
            $("#".concat(buttons[i].id)).on('click', buttons[i].action);
          }
        }
      }
    }

  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (this.$window.scrollTop() === 0) {
        this.$el.addClass(this.noShadowCSSClass).addClass(this.noShadowCSSClassBranding);
      } else {
        this.$el.removeClass(this.noShadowCSSClass).removeClass(this.noShadowCSSClassBranding);
      }
    }
  }]);
}();
svs.components.header = new svs.core.Events(new Header(svs.components.header.templates));

 })(window);